<template>
    <!-- 品牌牆 > 所有店家 > 更多 -->
    <div>
        <navigation-bar Back Bell/>
        <div class="main container">
            <el-row type="flex" justify="space-between">
                <el-col :span="6">
                    <el-button class="edit" round v-if="showHidden">編輯</el-button>
                </el-col>
                <el-col :span="18" class="buttons">
                    <img class="filter" src="@/assets/images/filter.svg" alt="" v-if="showHidden">
                    <img class="calendar" src="@/assets/images/icon-date2.svg" alt="" v-if="showHidden">
                </el-col>
            </el-row>
            <div>
                <category-content class="content" v-for="(item, index) in list" :key="index">
                    <el-row type="flex" class="store">
                        <el-col :span="7" type="flex" justify="center">
                          <div class="avatar" @click="$router.push({name: 'StoreInfo', query: {id: item.id}})"><el-image :src="item.imgLogoUrl" fit="cover"></el-image></div>
                        </el-col>
                        <el-col :span="17">
                            <ul class="text-left">
                                <li><h2 class="brand">{{item.brandName}} <span class="ml-3">{{item.name}}</span></h2></li>
                                <!--<li><p class="branch-name">— {{item.name}}</p></li>-->
                                <li class="business-hours" @click="item.showBusiness=!item.showBusiness">
                                    <span class="status">{{item.businessHours.businessStatusString}}．</span>{{item.businessHours.endBusinessTimePeriodString}}
                                    <i class="el-icon-caret-bottom" v-show="!item.showBusiness"></i>
                                    <i class="el-icon-caret-top" v-show="item.showBusiness"></i>
                                </li>
                                <li class="business-hours" v-show="item.showBusiness">
                                    <ul class="text-left">
                                        <li class="week">星期一 <span v-html="showBusinessTime(item.businessHours.monday)"></span></li>
                                        <li class="week">星期二 <span v-html="showBusinessTime(item.businessHours.tuesday)"></span></li>
                                        <li class="week">星期三 <span v-html="showBusinessTime(item.businessHours.wednesday)"></span></li>
                                        <li class="week">星期四 <span v-html="showBusinessTime(item.businessHours.thursday)"></span></li>
                                        <li class="week">星期五 <span v-html="showBusinessTime(item.businessHours.friday)"></span></li>
                                        <li class="week">星期六 <span v-html="showBusinessTime(item.businessHours.saturday)"></span></li>
                                        <li class="week">星期日 <span v-html="showBusinessTime(item.businessHours.sunday)"></span></li>
                                    </ul>
                                </li>
                            </ul>
                            <!--todo 外送資訊-->
                            <div class="takeout-list single" @click="isOpen(index)" v-if="false">
                                <div class="title">
                                    <i class="el-icon-goods"/>外送：
                                </div>
                                <div class="con">
                                    0-3km 滿$500 免運<br>
                                    3km以上-4km $50<br>
                                    5km以上-7km $100<br>
                                </div>
                                <div class="icon-arrow">
                                    <i class="el-icon-caret-bottom"/>
                                </div>
                            </div>
                            <div class="icons">
                                <el-button
                                    v-if="item.tel !== ''"
                                    type="text"
                                    @click="$public.callTel(item.tel)"
                                    class="store-phone-btn"/>
                                <el-button
                                    v-if="item.city !== ''"
                                    class="store-location-btn"
                                    type="text"
                                    @click="onClickLocationBtn(item.lat, item.lng)"/>
                            </div>
                        </el-col>
                        <!--<el-col :span="20">
                          <ul class="store-info">
                            <li><a @click="$public.callTel(item.tel)"><span>{{item.tel}}</span></a></li>
                            <li @click="$public.openMap(item.lat, item.lng)">{{item.city+item.township+item.address}}</li>
                          </ul>
                        </el-col>-->
                    </el-row>

                    <tag-list v-if="showHidden"/>
                </category-content>
            </div>

            <infinite-loading @infinite="setupDataScroll" spinner="waveDots" v-if="setupData">
                <div slot="no-more">沒有更多資料</div>
                <span slot="no-results"/>
            </infinite-loading>

            <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true" />
        </div>
        <comm-dialog v-show="!isLogin" :value="!isLogin" :outerContent="'請先登入'" :isCancel="false" :isModal="false" @result="onCommDialogClose"></comm-dialog>
    </div>
</template>

<script>
    import CategoryContent from '@/components/category/Content.vue';
    import TagList from '@/components/TagList.vue'
    import CommDialog from '@/components/CommDialog.vue'

    export default {
        name: "MyStore",
        components: {
            CategoryContent,
            TagList,
            CommDialog,
        },
        data() {
            return {
                isLoading: false,
                isLogin: this.$auth.isAdminLogin(),
                list: [],

                pageSize: 10,
                currentPage: 0,

                dayList: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
                weekDay: new Date().getDay(),
                showHidden: false,
                setupData: false,
                lng: 0,
                lat: 0,
            }
        },
        created() {
        },
        mounted() {
            let self = this;
            this.isLoading = true;
            let onSuccess = function(position) {
                self.lng = position.coords.longitude;
                self.lat = position.coords.latitude;
                self.isLoading = true;
                self.setupData = true;
            };
            let onError = function(error) {
                self.lng = 0;
                self.lat = 0;
                self.setupData = true;
                self.$public.showNotify("code: "+error.code+", message: "+error.message+"。無法定位GPS", false, 3000)
            };

            self.$public.getGpsLocation(onSuccess, onError);
        },
        methods: {
            setupDataScroll: function ($state) {
                //好友串門子
                let self = this;
                this.isLoading = true;
                //先撈附近店家-最近店家來顯示
                // this.$http.fetchWithAuth`AddStoreList${{
                //     offset: this.currentPage,
                // }}
                this.$http.fetchWithAuth`StoreList${{
                  searchType: 2,
                  offset: this.currentPage,
                  lng: self.lng,
                  lat: self.lat,
                }} ${json => {
                    if (json.data.length >= this.pageSize) {
                        this.currentPage++;
                        this.list.push(...json.data);
                        $state.loaded();
                    } else {
                        this.currentPage++;
                        this.list.push(...json.data);
                        $state.complete();
                    }
                    this.isLoading = false;
                }}`;
            },
            showBusinessTime: function (item) {
              if (item !== "休息日") {
                let showTime = "";
                item.forEach(function (value) {
                  showTime = showTime + value + '<br/>';
                })
                return showTime.slice(0, showTime.length-5);
              } else {
                return "休息日"
              }
            },
            /** CommDialog 關閉事件 */
            onCommDialogClose: function (result) {
                if (result) {
                    this.$router.push({name: 'Login'});
                }
            },
            isOpen(id){//外送詳細開合
                document.getElementsByClassName('takeout-list')[id].classList.toggle("open")
            },

            /** 點擊地點按鈕 */
            onClickLocationBtn: function (lat = 0, lng = 0, googleMapUrl = null) {
                if (this.$public.notNull(googleMapUrl) && googleMapUrl !== '') {
                    let param = this.$public.analyzeGoogleMapUrl(googleMapUrl);
                    if (this.$public.notNull(param)) {
                        //開啓地圖
                        if (this.$public.notNull(param.googleMapStoreInfoData) && param.googleMapLat > 0 && param.googleMapLng > 0) {
                            //爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面
                            this.$public.openMap(param.googleMapLat, param.googleMapLng, param.googleMapStoreInfoData);
                        } else {
                            this.$public.openMap(param.googleMapLat, param.googleMapLng);
                        }
                    }

                } else if (lat !== 0 && lng !== 0) {
                    this.$public.openMap(lat, lng);
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .edit {
        background: #F0D870;
        color: #fff;
        border: 0px;
        padding: 8px 14px
    }

    .buttons {
        display: flex;
        justify-content: flex-end
    }

    .filter {
        width: 80px;
        margin-right: 20px
    }

    .calendar {
        width: 25px;
    }

    .content {
        padding: 0 0 8px;
        margin-top: 10px;

        .el-col-7{
            margin-right: 10px;
        }
    }

    .avatar {
        background: #F6F5F4;
        width: 85px;
        height: 85px;
        padding: 3px;
        border-radius: 50%;
        overflow: hidden;
        box-sizing: content-box;
        border: 1px solid #D4D5D5;

        .el-image {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }

    .business-hours {
        font-size: 13px;
        color: #5F5E5E;

        .status {
            color: #E37E84;
        }
        .week{
            display: flex;
            span{
                margin-left: 8px;
            }
        }
    }

</style>